import { configureStore, combineReducers } from '@reduxjs/toolkit';
import rootReducer from './reducer';
import overViewReducer from './overview/overview.reducer.jsx';
import stores from './stores/stores.reducer.jsx';
import filter from "./filters/filter.reducer.jsx";

const store = configureStore({
  reducer: combineReducers({
    root: rootReducer,
    overview: overViewReducer,
    stores: stores,
    filter: filter,
  }),
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export default store;